import { BaseModel } from '../../core/abstractions/base.model';
import { CommandMapper } from '../../core/utils/mappers/command.mapper';
import { ServerRouteMapper } from '../../core/utils/mappers/server-route-mapper';
import { HttpMethodEnum } from '../enums/http-method.enum';
import { OptionalType } from '../types/optional.type';
import { ActionButtonModel } from './action-button.model';
import { CommandModel } from './command.model';

export class RelatedItemModel extends BaseModel {
    displayName: string;
    uri: string;
    httpMethod: HttpMethodEnum;
    parameterType: string;
    commandName: string;
    data?: any;
    referencedButton?: ActionButtonModel;

    constructor(init?: Partial<RelatedItemModel>) {
        super();
        Object.assign(this, init);
    }

    withRequest(model: string, id?: any, isSummary = true, httpMethod = HttpMethodEnum.Get): RelatedItemModel {
        this.httpMethod = httpMethod;
        // eslint-disable-next-line max-len
        this.uri = `/api${ServerRouteMapper.apiRoutesByType[model]}${id !== undefined ? `/${id}` : ''}${id !== undefined && isSummary ? '/summary' : ''}`;

        return this;
    }

    withItem(relatedItem: RelatedItemModel): RelatedItemModel {
        Object.assign(this, relatedItem);
        return this;
    }

    getCommand(): OptionalType<CommandModel> {
        return CommandMapper.commands.find(ac => ac.name === this.commandName);
    }
}
